import monitoring from '@clearscore/helpers.monitoring';
import { types as profileTypes } from '@clearscore/redux.profile';
import { types as marketTypes } from '@clearscore/redux.market';
import { types as novaUserActionTypes } from '@clearscore/redux.nova-user';
import { resolveProp } from '@clearscore/helpers.resolve-props';

/**
 * Send the action.type to monitoring as an info
 * @param {function} next next middleware func
 * @param {object} action redux action
 * @returns {void}
 */
function _sendAction(zone, next, action) {
    const { payload, type, requestMeta } = action;
    switch (type) {
        case marketTypes.MARKET_SET_ACTIVE_MARKET:
            monitoring.tag('market', resolveProp('market', payload));
            break;
        case profileTypes.PROFILE_FETCH_SUCCESS:
            monitoring.identity(resolveProp('uuid', payload));
            monitoring.tag('idv_status', resolveProp('accountIDVStatus', payload));
            break;
        case marketTypes.MARKET_FETCH_CONFIG_ERROR:
            monitoring.tag('market_fetch_config_error', resolveProp('market', requestMeta));
            break;
        case novaUserActionTypes.NOVA_USER_FETCH_SUCCESS:
            monitoring.identity(resolveProp('email', payload));
            monitoring.tag('user_roles', resolveProp('roles', payload));
            break;
        default:
            break;
    }

    if (action && action.type) {
        monitoring.addBreadcrumb({
            category: 'actions',
            message: `${zone}: [${action.type}]`,
            level: 'info',
        });
    }

    next(action);
}

/**
 * Pass all actions to the monitoring
 * @returns {Function} middleware
 */
const monitoringMiddleware = (zone) => () => (next) => (action) => _sendAction(zone, next, action);

export default monitoringMiddleware;
